import React from "react";
import { Route, Routes } from "react-router-dom";
import SignIn from "../Pages/Auth/signIn";
import ForgotPass from "../Pages/Auth/forgotPassword";
import ResetPass from "../Pages/Auth/resetPassword";
import SuccessPass from "../Pages/Auth/successPass";
import SignInPaymentExec from "../Pages/Auth/paymentExecutive";

const AuthRoutes = () => {
  return (
    <div>
      <Routes>
        <Route path="/" element={<SignIn />} />
        <Route
          path="/login_payment_exec"
          element={<SignInPaymentExec></SignInPaymentExec>}
        ></Route>
        <Route path="/forgot" element={<ForgotPass />} />
        <Route path="/reset-password" element={<ResetPass />} />
        <Route path="/password-success" element={<SuccessPass />} />
      </Routes>
    </div>
  );
};

export default AuthRoutes;
